<template>
  <div>
    <Loading />
    <BApp>
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
    </BApp>
  </div>
</template>

<script setup lang="ts">
import { BApp, useToast } from "bootstrap-vue-next";
import { useToastStore } from "~/stores/ui/toaststore";
import { useConfigurationsStore } from "~/stores/configurationsstore";
import type { ToastOrchestratorParam } from "bootstrap-vue-next";
import Loading from "@/components/shared/Loading.vue";
import { onMounted, watch } from "vue";
import type { NuxtPage, NuxtLayout } from "nuxt/schema";

// watch for toasts
const toast = useToast();
const toastStore = useToastStore();
onMounted(async () => {
  watch(
    () => toastStore.toasts,
    async (toasts) => {
      console.debug(toasts);
      for (const t of [...toasts]) {
        // copy to avoid mutation issues
        console.debug("show toast", t);
        await toast.show(t as ToastOrchestratorParam); // or toast.create(t).then(i => i.show())
        toastStore.removeToast(t.id);
      }
    },
    { immediate: true, deep: true },
  );
});

// watch for maintenance banner text to display toast
const configurationStore = useConfigurationsStore();
watch(
  () => configurationStore.getBannerText,
  (newVal, oldVal) => {
    if (newVal && newVal !== oldVal) {
      toastStore.addToastWithMessageAndTitle("Notice", newVal, "warning");
    }
  },
  { immediate: true },
);

// end watch for toasts
</script>
<style lang="scss" scoped>
.page-enter-active,
.page-leave-active {
  transition: all 0.4s;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
  filter: blur(1rem);
}
</style>
